export {useSFRAApplePayController} from './hooks/applepay-validateMerchant'
